export const filterColumnsPriority = [
    {
        label: 'education_type',
        rating: 1
    },
    {
        label: 'hours_number',
        rating: 2
    },
    {
        label: 'RF_location',
        rating: 3
    },
    {
        label: 'entry_date',
        rating: 4
    },
    {
        label: 'enrollment',
        rating: 5
    },
    {
        label: 'country',
        rating: 6
    },
    {
        label: 'gender',
        rating: 7
    },
    {
        label: 'payment_status',
        rating: 8
    },
    {
        label: 'first_payment_actual_date',
        rating: 9
    },
    {
        label: 'second_payment_actual_date',
        rating: 10
    },
    {
        label: 'third_payment_actual_date',
        rating: 11
    },
    {
        label: 'fourth_payment_actual_date',
        rating: 12
    },
    {
        label: 'transfer_to_international_service',
        rating: 13
    },
    {
        label: 'visa_validity',
        rating: 14
    },
    {
        label: 'actual_receipt_date_invitation',
        rating: 15
    },
    {
        label: 'form_study',
        rating: 16
    },
    {
        label: 'agent_company',
        rating: 17
    },
    {
        label: 'agent_name',
        rating: 18
    },
    {
        label: 'first_agent_email',
        rating: 19
    },
]
